module.exports = __webpack_public_path__ + "img/box.4c9fec05.png";